//--------------------------------------------
// get effective character armour dex penalty
//--------------------------------------------
export default function getCharacterArmourDexPen(character = null) {
  if (!character) return 0

  if (Array.isArray(character.armour_locations) && character.armour_locations.length > 0) {
    let total = 0

    character.armour_locations.forEach((loc) => {
      if (!loc) return

      const dp = Number(loc.dex_pen)
      if (!Number.isNaN(dp)) {
        total += dp
      }
    })

    return Math.floor(total)
  }

  const fieldValue = Number(character.dex_pen_percent_armour)
  if (!Number.isNaN(fieldValue)) {
    return Math.floor(fieldValue)
  }

  if (Array.isArray(character.items) && character.items.length > 0) {
    let total = 0

    character.items.forEach((item) => {
      const isEquippedArmour =
        item &&
        item.equipped &&
        (item.type === 'Armour' || item.coverage != null || item.layer != null)

      if (!isEquippedArmour) return

      const dp = Number(item.dex_pen)
      if (!Number.isNaN(dp) && dp >= 0) {
        total += dp
      }
    })

    return Math.floor(total)
  }

  return 0
}
